import { createSelector } from "reselect"
import { get, first, last } from "lodash"

export const getDates = state => get(state, "global.data.portfolioModelMeta.data.dates")
export const getProfileDate = state => get(state, "modules.portfolioRoot.profileDate")
export const getProfilePeriod = state => get(state, "modules.portfolioRoot.profilePeriod")

const getModelEarliestDate = state => get(state, "global.data.dates.data.model.availability.securitiesStartDate")
const getModelCurrentDate = state => get(state, "global.data.dates.data.model.availability.currentDate")

export const getLatestDate = createSelector(
  [getDates, getModelCurrentDate],
  (dates, modelCurrentDate) => {
    let endDate = first(dates)
    if (modelCurrentDate < endDate) {
      endDate = modelCurrentDate
    }
    return endDate
  },
)

export const getEarliestDate = createSelector(
  [getModelEarliestDate, getDates],
  (modelEarliestDate, dates) => modelEarliestDate > last(dates) ? modelEarliestDate : last(dates),
)
